import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import useT from "@/i18n";

export const Breadcrumbs = ({ items }) => {
  const { t, lp } = useT();
  return (
  <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1 text-xs text-slate-500">
      <li><Link to={lp("/")} className="tap inline-flex items-center hover:text-[#7DDCFF]">{t.crumbs.home}</Link></li>
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1">
          <CaretRight size={12} aria-hidden="true" />
          {i === items.length - 1 ? (
            <span aria-current="page" className="text-slate-300">{it.name}</span>
          ) : (
            <Link to={lp(it.path)} className="tap inline-flex items-center hover:text-[#7DDCFF]">{it.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
  );
};
